import type { ReactNode } from "react";
import { AccessLevelProvider } from "@/features/access/AccessLevelContext";
import { OnboardingProvider } from "@/features/onboarding/OnboardingProvider";
import { UserProvider } from "./UserContext";
import { SessionProvider } from "./SessionProvider";
import { AuthProvider } from "./AuthProvider";
import { ThemeProvider } from "./ThemeProvider";
import { NotificationProvider } from "./NotificationProvider";
import { GraphQLProvider } from "./GraphQLProvider";
import { ErrorProvider } from "./ErrorProvider";

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider>
      <AccessLevelProvider>
        <UserProvider>
          <SessionProvider>
            <AuthProvider>
              <OnboardingProvider>
                <NotificationProvider>
                  <ErrorProvider>
                    <GraphQLProvider>{children}</GraphQLProvider>
                  </ErrorProvider>
                </NotificationProvider>
              </OnboardingProvider>
            </AuthProvider>
          </SessionProvider>
        </UserProvider>
      </AccessLevelProvider>
    </ThemeProvider>
  );
}
